import { useDroppable } from "@dnd-kit/core";
import { Button } from "components/atoms";
import { ITrackForm } from "components/molecules/card/track-role/TrackRoleCard";
import { BUTTON_VARIANT } from "types/components/button/button.interface";

export type Album = {
  albumNumber: number;
  tracks: ITrackForm[];
};

const DroppableAlbumTab = ({
  album,
  isSelected,
  onSelect,
  isOver,
}: {
  album: Album;
  isSelected: boolean;
  onSelect: (number: number) => void;
  isOver: boolean;
}) => {
  const { setNodeRef } = useDroppable({
    id: `album-drop-${album.albumNumber}`,
  });

  return (
    <div ref={setNodeRef}>
      <Button
        isActive={isSelected}
        variant={BUTTON_VARIANT.white}
        onClick={() => onSelect(album.albumNumber)}
      >
        <Button.Text text={`Album ${album.albumNumber}`} />
      </Button>
    </div>
  );
};

export default DroppableAlbumTab;
